import { render } from "./Loading.vue?vue&type=template&id=7363fca4&scoped=true&ts=true"
import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=7363fca4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src231289078/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7363fca4"],['__file',"src/components/sgre/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7363fca4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7363fca4', __exports__)) {
    console.log('reload')
    api.reload('7363fca4', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=7363fca4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7363fca4', render)
  })

}


export default __exports__